import {
  BaseballIcon,
  BasketballIcon,
  FootballIcon,
  HockeyIcon,
  LoadingIcon,
  SoccerIcon,
} from "@sidelinesports/icons";
import styles from "./LoadingSpinner.module.css";

const ICONS = {
  LoadingIcon,
  BaseballIcon,
  BasketballIcon,
  FootballIcon,
  HockeyIcon,
  SoccerIcon,
};

export type LoadingSpinnerProps = {
  icon?:
    | "Loading"
    | "Baseball"
    | "Basketball"
    | "Football"
    | "Hockey"
    | "Soccer";
  size?: string;
};

export const LoadingSpinner = ({
  icon = "Loading",
  size = "1.5rem",
}: LoadingSpinnerProps) => {
  const Component = ICONS[`${icon}Icon`];

  return (
    // This containing div is necessary to prevent a bug in Chrome where, if you
    // apply a rotation directly to the SVG, it causes the body background to
    // get saturated while the animation is active
    <div
      className={styles.spinner}
      role="status"
      aria-label="Loading"
      style={
        {
          "--size": size,
        } as React.CSSProperties
      }
    >
      <Component />
    </div>
  );
};
